import { render, staticRenderFns } from "./TenantEditAccessLocks.vue?vue&type=template&id=b2556efe&"
import script from "./TenantEditAccessLocks.vue?vue&type=script&lang=js&"
export * from "./TenantEditAccessLocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports